/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const LOG_OUT = 'app/App/LOG_OUT';
export const GENERIC_ERROR = 'app/App/GENERIC_ERROR';
export const REPORT_TO_SEGMENT = 'app/App/REPORT_TO_SEGMENT';
export const AUDIENCE_BUILDER_VIEW = 'app/App/AUDIENCE_BUILDER_VIEW';
export const SURVEY_BUILDER_VIEW = 'app/App/SURVEY_BUILDER_VIEW';
export const ADD_SCREENING = 'app/App/ADD_SCREENING';
export const ADD_THREE_QUESTIONS = 'app/App/ADD_THREE_QUESTIONS';
export const ADD_QUESTION = 'app/App/ADD_QUESTION';
export const ADD_MIN_MAX = 'app/App/ADD_MIN_MAX';
export const QUESTIONNAIRE_UPDATE = 'app/App/QUESTIONNAIRE_UPDATE';
export const ANSWER_CREATE = 'app/App/ANSWER_CREATE';
export const DELETE_MEDIA = 'app/App/DELETE_MEDIA';
export const TRIGGER_AUTOSAVE_REVISION = 'app/App/TRIGGER_AUTOSAVE_REVISION';
export const TRACK_ANALYTICS_EVENT = 'app/App/TRACK_ANALYTICS_EVENT';
export const UNCONDITIONAL_HIDE_ANSWER = 'app/App/UNCONDITIONAL_HIDE_ANSWER';
export const SHOW_GENERAL_NOTIFICATION = 'app/App/SHOW_GENERAL_NOTIFICATION';

export const TRIGGER_AUTOSAVE_REVISION_INTERVAL = 30 * 1000; // 30 seconds

export const ANALYTICS_EVENTS_ENUM = {
  PREVIEW_NEW_TAB: 'diy_button_preview_newtab',
  PREVIEW_NEW_TAB_SUMMARY: 'diy_button_preview_newtab_summary',
  PREVIEW_MAIN: 'diy_button_preview_main',
  PREVIEW_PANE_OPEN_CLOSE: 'diy_button_preview_paneopenclose',
  PREVIEW_PANE_ADL_TAB: 'diy_button_preview_adltab',
  REVISIONS_OPEN_PANEL: 'qtnrevisions_panel',
  REVISIONS_CREATE: 'qtnrevisions_usercreate',
  REVISIONS_RESTORE: 'qtnrevisions_userrestore',
  AI_REPORT_FROM_SURVEYS: 'AIreport_visit_dashboard',
  AI_REPORT_FROM_SUMMARY: 'AIreport_visit_summary',
};

export const DEFAULT_BASENAME = '/dashboard';

export const MEDIA_QUERIES = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
  },
};

export const ROLE_ADMIN = 'admin';

export const ERROR_UPDATE_NOT_ALLOWED = 'ERROR_UPDATE_NOT_ALLOWED';
export const PERK_BIGQUERY_EXPORT = 'PERK_BIGQUERY_EXPORT';

// do not modify the actual string values because they
// are provided by the backend api
export const ERROR_TYPE_QUESTIONNAIRE_VERSION = 'ERROR_QUESTIONNAIRE_VERSION';
export const ERROR_TYPE_QUESTIONNAIRE_AND_TARGETING_VERSIONS =
  'ERROR_QUESTIONNAIRE_AND_TARGETING_VERSIONS';
export const ERROR_TYPE_PEEQ_COMMUNICATION = 'ERROR_PEEQ_COMMUNICATION';
export const ERROR_TYPE_GENERIC_ERROR = 'ERROR_TYPE_GENERIC_ERROR';

export const dayInMs = 86_400_000;
// export const MOBILE_VIEWPORT = 3000;
export const MOBILE_VIEWPORT = 800;

export const DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up',
  DOWN: 'down',
};

export const PAYMENT_MODE = {
  ADD: 'add',
  EDIT: 'edit',
  PURCHASED: 'purchased',
};

export const isDevelopment = process.env.NODE_ENV === 'development';
export const isStaging = window.location.hostname.includes('staging');

export const LETS_TALK_ELITE_URL =
  'https://www.pollfish.com/lets-talk/?plan=elite';
